import http from './api'

const route = 'app/brinde/'

export default {
  showGraficosDadosBrinde: (dataInicial, dataFinal, empresaSelect, vendedores, cidades, areas, tipoBrinde, motivoBrinde, tokencontrato, receita, segmento) => {
    return http.post(route + 'showGraficosDadosBrinde', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      vendedores: vendedores,
      cidades: cidades,
      areas: areas,
      tipoBrinde: tipoBrinde,
      motivoBrinde: motivoBrinde,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },
}
